// Function to get speaker details by their IDs
export const getSpeakersByIds = (speakerIds, speakers) => {

  // Map through each speaker ID and find the corresponding speaker object from the speakers array
  return speakerIds.map(id => speakers.find(speaker => speaker.id === id));

};